import styled from "styled-components";
import {Typography} from "@material-ui/core";

export const TokenValue = styled(Typography)`
  white-space: nowrap;
  font-size: 0.9rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 40px);
  align-self: center;
`;

export const TokenExpires = styled(Typography).attrs({
    variant: 'body2'
})`
  color: red;
  font-style: italic;
`;
